/** Route tabs (underline style) and a segmented sub-navigation — one markup for every tabbed console (D-2605). */
import type { ReactNode } from 'react';
import { NavLink } from 'react-router';

export interface RouteTab {
  /** Path segment appended to `base` ('' = index route). */
  id: string;
  label: ReactNode;
  /** Optional count shown in a pill. */
  count?: number | null;
  end?: boolean;
}

export function RouteTabs({
  base,
  tabs,
  label = 'Sections',
}: {
  base: string;
  tabs: RouteTab[];
  label?: string;
}) {
  return (
    <ul className="wdc-tabs" role="list" aria-label={label}>
      {tabs.map((t) => (
        <li key={t.id}>
          <NavLink to={`${base}${t.id ? `/${t.id}` : ''}`} end={t.end ?? true}>
            {t.label}
            {typeof t.count === 'number' ? (
              <span className="wdc-tabs__count wd-tabular">{t.count}</span>
            ) : null}
          </NavLink>
        </li>
      ))}
    </ul>
  );
}

/** Segmented control-style navigation for sub-areas (finance sections). */
export function SubNav({
  links,
  label,
}: {
  links: { to: string; label: ReactNode; end?: boolean }[];
  label: string;
}) {
  return (
    <nav aria-label={label} className="wdc-subnav">
      {links.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.end}>
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}
